module.exports = __webpack_public_path__ + "static/media/chat.4a52719e.png";